import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export function Input({
  label,
  error,
  icon,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-95">
      {label && <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-96">
          {label}
        </label>}
      <div className="relative" data-id="element-97">
        {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-98">
            {icon}
          </div>}
        <input className={`w-full px-4 py-3 bg-white border-2 border-slate-200 rounded-lg focus:outline-none focus:border-orange-500 transition-colors ${icon ? 'pl-10' : ''} ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-99" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-100">{error}</p>}
    </div>;
}